import * as React from "react"

export const HeightIcon: React.FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 23L7.5 18.3584L8.79452 16.9913L11.0753 19.3439V4.65607L8.79452 7.00867L7.5 5.64162L12 1L16.5 5.64162L15.2055 7.00867L12.9247 4.65607V19.3439L15.2055 16.9913L16.5 18.3584L12 23Z"
      fill="#616161"
    />
  </svg>
)
